<script setup lang="ts">
import type { LandingIconName } from '../types/landing.types'

/**
 * Icono del set Unicons (line) que ya sirve el proyecto localmente
 * (`src/styles/unicons.css`). Sustituye a los emojis que usaba el landing:
 * un set de una sola tinta, monocromo y con el color del texto, en lugar de
 * los pictogramas multicolor de sistema.
 *
 * El glifo se pinta por el pseudo-elemento `:before` de la clase `uil-*`,
 * asi que el tamano lo fija el `font-size` del contenedor.
 */
defineProps<{ name: LandingIconName }>()
</script>

<template>
  <i class="uil" :class="`uil-${name}`" aria-hidden="true" />
</template>
